<template>
  <div class="Section PrefContent-companyName">
    <div class="PrefContent-profile">
      <div class="PrefContent-profileContent">
        <div class="Form-field">
          <h2>Company Logo</h2>
          <div class="PrefContent-logo">
            <div v-if="companyData.logo !== null">
              <img
                v-if="companyData.logo !== null"
                :src="companyData.logo"
                :alt="companyData.name"
              >
            </div>
            <div v-else>
              Logo not uploaded.
            </div>
          </div>
        </div>
        <div class="Form-field">
          <h2>Visible Company Name</h2>
          {{ companyData.name }}
        </div>
      </div>
      <div class="Notice Notice--warning mgTop-m">
        <p
          v-if="companyData.logo === null"
          class="Notice-copy"
        >
          {{ copy.noLogoNotice }}
        </p>
        <p class="Notice-copy">
          Please visit the <a :href="editCompanyDetailsUrl">Company Details</a>
          page to change your logo and visible company name.
        </p>
        <p class="Notice-copy">
          The logo and visible company name will be used in email communications to students and when they
          login to the preference centre.
        </p>
      </div>
      <a
        :href="editCompanyDetailsUrl"
        class="Button Button--blue"
      >Edit Company Details</a>
    </div>
  </div>
</template>

<script>
import LocalCopy from '../../../lang/en.json';

export default {
  props: {
    companyData: {
      type: Object,
      required: true,
      default() {
        return null;
      },
    },
    editCompanyDetailsUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      defaultImage: {
        src: '',
        name: 'No logo uploaded',
      },
    };
  },
  computed: {
    copy() {
      return LocalCopy.studentPreferenceCenter.companyDetails;
    },
  },
};
</script>
